import React from 'react';
import Title from '@components/molecules/Title/Title';
import PropTypes from 'prop-types';
import {
  MultiStepSubtitle,
  MultiStepTitleWrapper,
} from './MultiStepTitle.styled';

const MultiStepTitle = ({ title, subtitle }) => {
  return (
    <MultiStepTitleWrapper>
      <Title title={title} />
      <MultiStepSubtitle>{subtitle}</MultiStepSubtitle>
    </MultiStepTitleWrapper>
  );
};

MultiStepTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default MultiStepTitle;
